export const demo = {
  test: '/static/data.json'
}



// WEBPACK FOOTER //
// ./src/config/req.conf.js